// Lib
import React, { useEffect } from 'react';
import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { first } from 'lodash/fp';

// Utils
import platformSingleton from '../../../../platform/platformSingleton';
import { asObject } from '../../../../../common/utils/immutableHelper';
import { isPlatformElectronMac } from '../../../../platform/utils/platformDetailsUtils';

// Actions
import { fetchCmsData } from '../../../../cms/cmsActions';

// Selectors
import { getCmsData } from '../../../../cms/cmsSelector';

// Components
import Icon from '../../../../components/icons/Icon';
import HelpPopup from './HelpPopup';
import TooltipSource from '../../../../components/tooltips/TooltipSource';
import PopupTrigger from '../../../../components/popupPanel/PopupTrigger';

// Constants
import { CmsEntities } from '../../../../cms/cmsConstants';
import { PopupIds, PopupSections } from '../../../../components/popupPanel/popupConstants';

// Styles
import './HelpUtil.scss';

const getReleaseInfoSelector = createSelector(getCmsData(CmsEntities.RELEASES), (data) => first(asObject(data)));

const mapStateToProps = createStructuredSelector({
    releaseInfo: getReleaseInfoSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchReleaseInfo: () =>
        dispatch(
            fetchCmsData(CmsEntities.RELEASES)({
                platform: isPlatformElectronMac(platformSingleton) ? 'MacOS' : 'Web',
            }),
        ),
});

const HelpUtil = ({ tooltipEnabled, releaseInfo, dispatchFetchReleaseInfo }) => {
    useEffect(() => {
        dispatchFetchReleaseInfo();
    }, []);

    return (
        <div className="HeaderUtil HelpUtil" id="header-help-util">
            <TooltipSource tooltipText="Help" distance={0} delay={700} enabled={tooltipEnabled} triggerOnMouseEnter>
                <PopupTrigger
                    popupId={PopupIds.HELP}
                    className="header-util-button"
                    closeSection={PopupSections.HEADER}
                >
                    {(popupIsOpen) => (
                        <div className="header-util-button-content">
                            <Icon name="nav-help" />
                        </div>
                    )}
                </PopupTrigger>
            </TooltipSource>
            <HelpPopup releaseInfo={releaseInfo} fetchReleaseInfo={dispatchFetchReleaseInfo} />
        </div>
    );
};

HelpUtil.propTypes = {
    isGuest: PropTypes.bool,
    unreadMessageCount: PropTypes.number,
    tooltipEnabled: PropTypes.bool,
    shouldDelayTooltip: PropTypes.bool,
    fetchReleaseInfo: PropTypes.func,

    releaseInfo: PropTypes.object,
    dispatchFetchReleaseInfo: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpUtil);
